<template>
    <div>
        <b-form enctype="multipart/form-data">
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Data"
                    label-for="initialDate"
                    :label-cols="3"
                    :horizontal="true">
                        <b-row>
                            <b-col cols=4>
                                <b-form-input v-model="initialDate" type="date" id="paymentinitialDateDate" :class="initialDateField"></b-form-input>              
                            </b-col>
                        </b-row>
                    </b-form-group>          
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Valor"
                    label-for="initialBalance"
                    :label-cols="3"
                    :horizontal="true">
                        <b-row>
                            <b-col cols=4>
                                <b-form-input v-model="initialBalance" id="initialBalance" type="number" :class="initialBalanceField"></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>          
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Observação"
                    label-for="initialNotes"
                    :horizontal="false">
                        <b-form-textarea
                            id="initialNotes"
                            v-model="initialNotes"
                            placeholder=""
                            rows="5"
                        ></b-form-textarea>
                    </b-form-group>          
                </b-col>
            </b-row>

          
        </b-form>

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>
    
        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="addPayment()"><i class="fa fa-check"></i><span>Adicionar Pagamento</span></b-button>
        </div>

    </div>    
</template>


<script>
import Vue from 'vue'
import axios from "axios";

//import ProductSelectComponent from '../stock/ProductSelectComponent'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

import PaymentGridComponent from './PaymentGridComponent'

const toastTypes = {
success: 'success',
error: 'error',
info: 'info',
warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
return miniToastr[type](message, title, timeout, cb)
}

const options = {
success: toast,
error: toast,
info: toast,
warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'paymentComponent',
    props: {
        item: Object,
        companyId: Number
    },
    watch: {
       
    },
    components: {

    },
    data: () => {
        return {
            initialDateField: '',
            initialBalanceField: '',
            
            initialDate: '',
            initialBalance: null,
            initialNotes: '',

            errorMessage: ""

        }
    },
    computed: {
       selectedItem() {
            return this.item
       }
    },
    methods: {

        async saveItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            /*
            let formData = {
                accountId: s.selectedItem.id,
                balance: s.initialBalance,
                balanceDate: new Date(s.initialDate + "T12:00:00.000Z"),
                notes: s.initialNotes,
                uid: currentUser.id,
                sid: currentUser.sid
            }
            */
            let formData = {
                accountId: s.selectedItem.id,
                name: "Saldo inicial",
                movementStatusId: 3,
                movementTypeId: 1,
                movementSubtypeId: 2,
                date: new Date(s.initialDate + "T12:00:00.000Z"),
                movementValue: s.initialBalance,
                notes: s.initialNotes,                
                uid: currentUser.id,
                sid: currentUser.sid
            }
            
            var url = this.$store.state.ws_url + "/finance/account/movement"

            await axios.post(
                url,
                formData
            ).then(function(resp) {
                s.$emit('resp', { code: 1, message: "Saldo inicial incluído"});

            }).catch(function(error) {
                console.log(error)
            })
        },

        addPayment() {

            var containsError = false
            
            if(this.initialDate == null || this.initialDate == '') {
                this.initialDateField = 'is-invalid'
                containsError = true
            }
            else {
                this.initialDateField = ''
            }

            if(this.initialBalance == null || this.initialBalance <= 0) {
                this.initialBalanceField = 'is-invalid'
                containsError = true
            }
            else {
                this.initialBalanceField = ''
            }
            
            if(!containsError) {
                this.saveItem();
            }

        }
    },
    mounted: function() {
    }

}

</script>